export const ManageCommonAbnormality = {
   "library" : {
      "annotation" : [ {
         "translatorOptions" : "",
         "type" : "CqlToElmInfo"
      } ],
      "identifier" : {
         "id" : "ManageCommonAbnormality",
         "version" : "1.1.0"
      },
      "schemaIdentifier" : {
         "id" : "urn:hl7-org:elm",
         "version" : "r1"
      },
      "usings" : {
         "def" : [ {
            "localIdentifier" : "System",
            "uri" : "urn:hl7-org:elm-types:r1"
         }, {
            "localIdentifier" : "FHIR",
            "uri" : "http://hl7.org/fhir",
            "version" : "4.0.1"
         } ]
      },
      "includes" : {
         "def" : [ {
            "localIdentifier" : "FHIRHelpers",
            "path" : "FHIRHelpers",
            "version" : "4.0.1"
         }, {
            "localIdentifier" : "Dash",
            "path" : "DashboardLibrary",
            "version" : "1.0.0"
         }, {
            "localIdentifier" : "Collate",
            "path" : "CollateManagementData",
            "version" : "1.1.0"
         }, {
            "localIdentifier" : "RiskTableLookup",
            "path" : "AutogeneratedTableLookup",
            "version" : "1.0.0"
         } ]
      },
      "contexts" : {
         "def" : [ {
            "name" : "Patient"
         } ]
      },
      "statements" : {
         "def" : [ {
            "name" : "Patient",
            "context" : "Patient",
            "expression" : {
               "type" : "SingletonFrom",
               "operand" : {
                  "dataType" : "{http://hl7.org/fhir}Patient",
                  "templateId" : "http://hl7.org/fhir/StructureDefinition/Patient",
                  "type" : "Retrieve"
               }
            }
         }, {
            "name" : "LookUpTable1",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetGeneralScreeningManagement",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "SecondMostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "RowTable1",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetRowTable1",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "SecondMostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "AdjacentRowsTable1",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetAdjacentRowsTable1",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "SecondMostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "GeneralScreeningManagementRecommendation",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "LookUpTable1",
                           "type" : "ExpressionRef"
                        }
                     }
                  }
               },
               "then" : {
                  "path" : "action",
                  "type" : "Property",
                  "source" : {
                     "name" : "LookUpTable1",
                     "type" : "ExpressionRef"
                  }
               },
               "else" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  }
               }
            }
         }, {
            "name" : "LookUpTable2",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetSurveillanceManagement",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "ThirdMostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "RowTable2",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetRowTable2",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "ThirdMostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "AdjacentRowsTable2",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetAdjacentRowsTable2",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "ThirdMostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentCytologyCotestResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "SurveillanceManagementRecommendation",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "LookUpTable2",
                           "type" : "ExpressionRef"
                        }
                     }
                  }
               },
               "then" : {
                  "path" : "action",
                  "type" : "Property",
                  "source" : {
                     "name" : "LookUpTable2",
                     "type" : "ExpressionRef"
                  }
               },
               "else" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  }
               }
            }
         }, {
            "name" : "LookUpTable3",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetColposcopyResultsManagement",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "ReferringHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ReferringCytologyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentBiopsyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "RowTable3",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetRowTable3",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "ReferringHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ReferringCytologyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentBiopsyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "AdjacentRowsTable3",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetAdjacentRowsTable3",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "ReferringHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ReferringCytologyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentBiopsyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "ColposcopyResultsManagementRecommendation",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "LookUpTable3",
                           "type" : "ExpressionRef"
                        }
                     }
                  }
               },
               "then" : {
                  "path" : "action",
                  "type" : "Property",
                  "source" : {
                     "name" : "LookUpTable3",
                     "type" : "ExpressionRef"
                  }
               },
               "else" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  }
               }
            }
         }, {
            "name" : "LookUpTable4",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetPostColposcopyManagement",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "ReferringHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ReferringCytologyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentBiopsyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentHpvResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentCytologyResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentHpvResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentCytologyResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentHpvResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentCytologyResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "RowTable4",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetRowTable4",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "ReferringHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ReferringCytologyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentBiopsyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentHpvResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentCytologyResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentHpvResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentCytologyResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentHpvResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentCytologyResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "AdjacentRowsTable4",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetAdjacentRowsTable4",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "ReferringHpvResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ReferringCytologyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentBiopsyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentHpvResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentCytologyResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentHpvResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentCytologyResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentHpvResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentCytologyResultPostBiopsy",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "PostColposcopyManagementRecommendation",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "LookUpTable4",
                           "type" : "ExpressionRef"
                        }
                     }
                  }
               },
               "then" : {
                  "path" : "action",
                  "type" : "Property",
                  "source" : {
                     "name" : "LookUpTable4",
                     "type" : "ExpressionRef"
                  }
               },
               "else" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  }
               }
            }
         }, {
            "name" : "LookUpTable5",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetPostTreatmentManagement",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "MostRecentBiopsyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentHpvResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentCytologyResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentHpvResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentCytologyResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentHpvResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentCytologyResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "RowTable5",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetRowTable5",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "MostRecentBiopsyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentHpvResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentCytologyResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentHpvResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentCytologyResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentHpvResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentCytologyResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "AdjacentRowsTable5",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "GetAdjacentRowsTable5",
               "libraryName" : "RiskTableLookup",
               "type" : "FunctionRef",
               "operand" : [ {
                  "name" : "MostRecentBiopsyResult",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentHpvResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ThirdMostRecentCytologyResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentHpvResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SecondMostRecentCytologyResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentHpvResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "MostRecentCytologyResultAfterTreatment",
                  "libraryName" : "Collate",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "PostTreatmentManagementRecommendation",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "If",
               "condition" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Boolean",
                  "type" : "As",
                  "operand" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "LookUpTable5",
                           "type" : "ExpressionRef"
                        }
                     }
                  }
               },
               "then" : {
                  "path" : "action",
                  "type" : "Property",
                  "source" : {
                     "name" : "LookUpTable5",
                     "type" : "ExpressionRef"
                  }
               },
               "else" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}String",
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  }
               }
            }
         }, {
            "name" : "TableRecommendation",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "Coalesce",
               "operand" : [ {
                  "name" : "PostTreatmentManagementRecommendation",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "PostColposcopyManagementRecommendation",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "ColposcopyResultsManagementRecommendation",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "SurveillanceManagementRecommendation",
                  "type" : "ExpressionRef"
               }, {
                  "name" : "GeneralScreeningManagementRecommendation",
                  "type" : "ExpressionRef"
               } ]
            }
         }, {
            "name" : "WhichTableMadeTheRecommendation",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "Case",
               "caseItem" : [ {
                  "when" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "PostTreatmentManagementRecommendation",
                           "type" : "ExpressionRef"
                        }
                     }
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                     "value" : "5",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "PostColposcopyManagementRecommendation",
                           "type" : "ExpressionRef"
                        }
                     }
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                     "value" : "4",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "ColposcopyResultsManagementRecommendation",
                           "type" : "ExpressionRef"
                        }
                     }
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                     "value" : "3",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "SurveillanceManagementRecommendation",
                           "type" : "ExpressionRef"
                        }
                     }
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                     "value" : "2",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "GeneralScreeningManagementRecommendation",
                           "type" : "ExpressionRef"
                        }
                     }
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                     "value" : "1",
                     "type" : "Literal"
                  }
               } ],
               "else" : {
                  "asType" : "{urn:hl7-org:elm-types:r1}Integer",
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  }
               }
            }
         }, {
            "name" : "CommonAbnormalityGroup",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "Case",
               "caseItem" : [ {
                  "when" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "PostTreatmentManagementRecommendation",
                           "type" : "ExpressionRef"
                        }
                     }
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "Post Treatment (Table 5)",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "PostColposcopyManagementRecommendation",
                           "type" : "ExpressionRef"
                        }
                     }
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "Post Colposcopy (Table 4)",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "ColposcopyResultsManagementRecommendation",
                           "type" : "ExpressionRef"
                        }
                     }
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "Colposcopy Results (Table 3)",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "SurveillanceManagementRecommendation",
                           "type" : "ExpressionRef"
                        }
                     }
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "Surveillance (Table 2)",
                     "type" : "Literal"
                  }
               }, {
                  "when" : {
                     "type" : "Not",
                     "operand" : {
                        "type" : "IsNull",
                        "operand" : {
                           "name" : "GeneralScreeningManagementRecommendation",
                           "type" : "ExpressionRef"
                        }
                     }
                  },
                  "then" : {
                     "valueType" : "{urn:hl7-org:elm-types:r1}String",
                     "value" : "General Screening (Table 1)",
                     "type" : "Literal"
                  }
               } ],
               "else" : {
                  "valueType" : "{urn:hl7-org:elm-types:r1}String",
                  "value" : "N/A",
                  "type" : "Literal"
               }
            }
         }, {
            "name" : "ReflexTestingRecommendationText",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "valueType" : "{urn:hl7-org:elm-types:r1}String",
               "value" : "Per the ASCCP Risk Management Guidelines (Egemen et al.), reflex testing with cervical cytology is indicated as surveillance given the patient's history of abnormal results in order to provide an evidence-based care recommendation.",
               "type" : "Literal"
            }
         }, {
            "name" : "J1RecommendationText",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "valueType" : "{urn:hl7-org:elm-types:r1}String",
               "value" : "After abnormal cervical cancer screening test results for patients 25 years or older, colposcopic biopsy results, or treatment of histologic HSIL, surveillance with either HPV testing alone or cotesting is preferred (AI). Surveillance with cervical cytology alone is acceptable only if testing with HPV or cotesting is not feasible (CIII). Cytology is recommended at 6-month intervals when 1-year intervals are recommended for HPV or cotesting, and annually when 3-year intervals are recommended for HPV or cotesting (AII).",
               "type" : "Literal"
            }
         }, {
            "name" : "TreatmentWithPregnancyConcernsRecommendationText",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "valueType" : "{urn:hl7-org:elm-types:r1}String",
               "value" : "Endocervical curettage, endometrial biopsy, and treatment without biopsy are unacceptable during pregnancy (EIII). A diagnostic excisional procedure or repeat biopsy is recommended only if cancer is suspected based on cytology, colposcopy, or histology (BII). For patients with a diagnosis of histologic HSIL (CIN 2) whose concerns about the effects of treatment on a future pregnancy outweigh their concerns about cancer, either observation or treatment is acceptable provided the squamocolumnar junction is visible and CIN 2+ or ungraded CIN is not identified on endocervical sampling (CII). If the histologic HSIL cannot be specified as CIN 2, treatment is preferred, but observation is acceptable if there are concerns related to future pregnancies (CIII). For patients 25 years or older, observation includes colposcopy and HPV-based testing with cotest or primary hrHPV testing at 6-month intervals for up to 2 years.",
               "type" : "Literal"
            }
         }, {
            "name" : "OneYearSurveillanceRecommendationText",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "valueType" : "{urn:hl7-org:elm-types:r1}String",
               "value" : "When patients have an estimated risk of CIN 3+ based on history and current results that is below the threshold for immediate colposcopy (4.0% immediate risk) and above the 3-year follow-up threshold (≥0.55% at 5 years), repeat testing in 1 year with HPV-based testing is recommended (AII).",
               "type" : "Literal"
            }
         }, {
            "name" : "ThreeYearSurveillanceRecommendationText",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "valueType" : "{urn:hl7-org:elm-types:r1}String",
               "value" : "When patients have an estimated 5-year CIN 3+ risk of 0.15% or greater but less than 0.55% based on history and current test results, repeat testing in 3 years with HPV-based testing is recommended (AII).",
               "type" : "Literal"
            }
         }, {
            "name" : "FiveYearSurveillanceRecommendationText",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "valueType" : "{urn:hl7-org:elm-types:r1}String",
               "value" : "When patients have an estimated 5-year CIN 3+ risk of less than 0.15% based on past history and current test results, return to routine screening at 5-year intervals using HPV-based testing is recommended (AII).",
               "type" : "Literal"
            }
         }, {
            "name" : "ColposcopyRecommendationText",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "valueType" : "{urn:hl7-org:elm-types:r1}String",
               "value" : "For patients 25 years or older, when patients have an estimated immediate risk of diagnosis of CIN 3+ of 4.0% or greater based on history and current results, referral to colposcopy is recommended (AII). Endocervical curettage, endometrial biopsy, and treatment without biopsy are unacceptable during pregnancy (EIII). A diagnostic excisional procedure or repeat biopsy is recommended only if cancer is suspected based on cytology, colposcopy, or histology (BII).",
               "type" : "Literal"
            }
         }, {
            "name" : "ColposcopyOrTreatmentRecommendationText",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "valueType" : "{urn:hl7-org:elm-types:r1}String",
               "value" : "For nonpregnant patients 25 years or older with an estimated immediate risk of CIN 3+ 25% or greater and less than 60% based on history and current results, treatment using an excisional procedure without previous biopsy confirmation or histologic evaluation with colposcopy and biopsy are both acceptable (AII).",
               "type" : "Literal"
            }
         }, {
            "name" : "TreatmentRecommendationText",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "valueType" : "{urn:hl7-org:elm-types:r1}String",
               "value" : "For nonpregnant patients 25 years or older with an estimated immediate risk of CIN 3+ of 60% or greater based on history and current results, treatment using an excisional procedure without previous biopsy confirmation is preferred but colposcopy with biopsy is acceptable (BII).",
               "type" : "Literal"
            }
         }, {
            "name" : "Over65RecommendationText",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "valueType" : "{urn:hl7-org:elm-types:r1}String",
               "value" : "If patients over age 65 years undergo HPV testing, cotesting, or cytology, management according to guidelines for patients aged 25 to 65 years is recommended (CII). If surveillance testing is recommended for either a history of abnormal screening results or treatment for precancer, discontinuing surveillance is unacceptable if the patient is in reasonably good health and testing is feasible (DII). Discontinuation of surveillance is recommended for patients with a limited life expectancy (EIII). This population will be managed based on logic defined for rare abnormalities and common abnormalities.",
               "type" : "Literal"
            }
         }, {
            "name" : "PositivePrimaryHpv",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "And",
               "operand" : [ {
                  "type" : "AnyTrue",
                  "source" : {
                     "type" : "Query",
                     "source" : [ {
                        "alias" : "aC",
                        "expression" : {
                           "path" : "allConclusions",
                           "type" : "Property",
                           "source" : {
                              "name" : "MostRecentHpvReport",
                              "libraryName" : "Collate",
                              "type" : "ExpressionRef"
                           }
                        }
                     } ],
                     "relationship" : [ ],
                     "return" : {
                        "expression" : {
                           "type" : "InValueSet",
                           "code" : {
                              "name" : "ToConcept",
                              "libraryName" : "FHIRHelpers",
                              "type" : "FunctionRef",
                              "operand" : [ {
                                 "name" : "aC",
                                 "type" : "AliasRef"
                              } ]
                           },
                           "valueset" : {
                              "name" : "High Risk HPV Positive Results",
                              "libraryName" : "Dash",
                              "type" : "ValueSetRef"
                           }
                        }
                     }
                  }
               }, {
                  "type" : "IsNull",
                  "operand" : {
                     "name" : "MostRecentCytologyCotest",
                     "libraryName" : "Collate",
                     "type" : "ExpressionRef"
                  }
               } ]
            }
         }, {
            "name" : "Action",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "Case",
               "caseItem" : [ {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "name" : "PositivePrimaryHpv",
                           "type" : "ExpressionRef"
                        }, {
                           "type" : "Not",
                           "operand" : {
                              "type" : "After",
                              "operand" : [ {
                                 "path" : "date",
                                 "type" : "Property",
                                 "source" : {
                                    "name" : "MostRecentCytologyReport",
                                    "libraryName" : "Collate",
                                    "type" : "ExpressionRef"
                                 }
                              }, {
                                 "path" : "date",
                                 "type" : "Property",
                                 "source" : {
                                    "name" : "MostRecentHpvReport",
                                    "libraryName" : "Collate",
                                    "type" : "ExpressionRef"
                                 }
                              } ]
                           }
                        } ]
                     }, {
                        "type" : "Not",
                        "operand" : {
                           "type" : "After",
                           "operand" : [ {
                              "path" : "date",
                              "type" : "Property",
                              "source" : {
                                 "name" : "MostRecentBiopsyReport",
                                 "libraryName" : "Collate",
                                 "type" : "ExpressionRef"
                              }
                           }, {
                              "path" : "date",
                              "type" : "Property",
                              "source" : {
                                 "name" : "MostRecentHpvReport",
                                 "libraryName" : "Collate",
                                 "type" : "ExpressionRef"
                              }
                           } ]
                        }
                     } ]
                  },
                  "then" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "short",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "Cytology",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "date",
                        "value" : {
                           "type" : "Today"
                        }
                     }, {
                        "name" : "details",
                        "value" : {
                           "type" : "List",
                           "element" : [ {
                              "name" : "ReflexTestingRecommendationText",
                              "type" : "ExpressionRef"
                           } ]
                        }
                     } ]
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "GreaterOrEqual",
                           "operand" : [ {
                              "precision" : "Year",
                              "type" : "CalculateAge",
                              "operand" : {
                                 "path" : "birthDate.value",
                                 "type" : "Property",
                                 "source" : {
                                    "name" : "Patient",
                                    "type" : "ExpressionRef"
                                 }
                              }
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                              "value" : "25",
                              "type" : "Literal"
                           } ]
                        }, {
                           "type" : "LessOrEqual",
                           "operand" : [ {
                              "precision" : "Year",
                              "type" : "CalculateAge",
                              "operand" : {
                                 "path" : "birthDate.value",
                                 "type" : "Property",
                                 "source" : {
                                    "name" : "Patient",
                                    "type" : "ExpressionRef"
                                 }
                              }
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                              "value" : "65",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "TableRecommendation",
                           "type" : "ExpressionRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "1-year follow-up",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "short",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "Surveillance",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "date",
                        "value" : {
                           "type" : "Add",
                           "operand" : [ {
                              "name" : "DateOfMostRecentReport",
                              "libraryName" : "Collate",
                              "type" : "ExpressionRef"
                           }, {
                              "value" : 1,
                              "unit" : "year",
                              "type" : "Quantity"
                           } ]
                        }
                     }, {
                        "name" : "details",
                        "value" : {
                           "type" : "List",
                           "element" : [ {
                              "name" : "OneYearSurveillanceRecommendationText",
                              "type" : "ExpressionRef"
                           }, {
                              "name" : "J1RecommendationText",
                              "type" : "ExpressionRef"
                           } ]
                        }
                     } ]
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "Greater",
                        "operand" : [ {
                           "precision" : "Year",
                           "type" : "CalculateAge",
                           "operand" : {
                              "path" : "birthDate.value",
                              "type" : "Property",
                              "source" : {
                                 "name" : "Patient",
                                 "type" : "ExpressionRef"
                              }
                           }
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                           "value" : "65",
                           "type" : "Literal"
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "TableRecommendation",
                           "type" : "ExpressionRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "1-year follow-up",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "short",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "Surveillance",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "date",
                        "value" : {
                           "type" : "Add",
                           "operand" : [ {
                              "name" : "DateOfMostRecentReport",
                              "libraryName" : "Collate",
                              "type" : "ExpressionRef"
                           }, {
                              "value" : 1,
                              "unit" : "year",
                              "type" : "Quantity"
                           } ]
                        }
                     }, {
                        "name" : "details",
                        "value" : {
                           "type" : "List",
                           "element" : [ {
                              "name" : "OneYearSurveillanceRecommendationText",
                              "type" : "ExpressionRef"
                           }, {
                              "name" : "J1RecommendationText",
                              "type" : "ExpressionRef"
                           }, {
                              "name" : "Over65RecommendationText",
                              "type" : "ExpressionRef"
                           } ]
                        }
                     } ]
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "GreaterOrEqual",
                           "operand" : [ {
                              "precision" : "Year",
                              "type" : "CalculateAge",
                              "operand" : {
                                 "path" : "birthDate.value",
                                 "type" : "Property",
                                 "source" : {
                                    "name" : "Patient",
                                    "type" : "ExpressionRef"
                                 }
                              }
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                              "value" : "25",
                              "type" : "Literal"
                           } ]
                        }, {
                           "type" : "LessOrEqual",
                           "operand" : [ {
                              "precision" : "Year",
                              "type" : "CalculateAge",
                              "operand" : {
                                 "path" : "birthDate.value",
                                 "type" : "Property",
                                 "source" : {
                                    "name" : "Patient",
                                    "type" : "ExpressionRef"
                                 }
                              }
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                              "value" : "65",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "TableRecommendation",
                           "type" : "ExpressionRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "3-year follow-up",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "short",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "Surveillance",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "date",
                        "value" : {
                           "type" : "Add",
                           "operand" : [ {
                              "name" : "DateOfMostRecentReport",
                              "libraryName" : "Collate",
                              "type" : "ExpressionRef"
                           }, {
                              "value" : 3,
                              "unit" : "years",
                              "type" : "Quantity"
                           } ]
                        }
                     }, {
                        "name" : "details",
                        "value" : {
                           "type" : "List",
                           "element" : [ {
                              "name" : "ThreeYearSurveillanceRecommendationText",
                              "type" : "ExpressionRef"
                           }, {
                              "name" : "J1RecommendationText",
                              "type" : "ExpressionRef"
                           } ]
                        }
                     } ]
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "Greater",
                        "operand" : [ {
                           "precision" : "Year",
                           "type" : "CalculateAge",
                           "operand" : {
                              "path" : "birthDate.value",
                              "type" : "Property",
                              "source" : {
                                 "name" : "Patient",
                                 "type" : "ExpressionRef"
                              }
                           }
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                           "value" : "65",
                           "type" : "Literal"
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "TableRecommendation",
                           "type" : "ExpressionRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "3-year follow-up",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "short",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "Surveillance",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "date",
                        "value" : {
                           "type" : "Add",
                           "operand" : [ {
                              "name" : "DateOfMostRecentReport",
                              "libraryName" : "Collate",
                              "type" : "ExpressionRef"
                           }, {
                              "value" : 3,
                              "unit" : "years",
                              "type" : "Quantity"
                           } ]
                        }
                     }, {
                        "name" : "details",
                        "value" : {
                           "type" : "List",
                           "element" : [ {
                              "name" : "ThreeYearSurveillanceRecommendationText",
                              "type" : "ExpressionRef"
                           }, {
                              "name" : "J1RecommendationText",
                              "type" : "ExpressionRef"
                           }, {
                              "name" : "Over65RecommendationText",
                              "type" : "ExpressionRef"
                           } ]
                        }
                     } ]
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "GreaterOrEqual",
                           "operand" : [ {
                              "precision" : "Year",
                              "type" : "CalculateAge",
                              "operand" : {
                                 "path" : "birthDate.value",
                                 "type" : "Property",
                                 "source" : {
                                    "name" : "Patient",
                                    "type" : "ExpressionRef"
                                 }
                              }
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                              "value" : "25",
                              "type" : "Literal"
                           } ]
                        }, {
                           "type" : "LessOrEqual",
                           "operand" : [ {
                              "precision" : "Year",
                              "type" : "CalculateAge",
                              "operand" : {
                                 "path" : "birthDate.value",
                                 "type" : "Property",
                                 "source" : {
                                    "name" : "Patient",
                                    "type" : "ExpressionRef"
                                 }
                              }
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                              "value" : "65",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "TableRecommendation",
                           "type" : "ExpressionRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "5-year follow-up",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "short",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "Surveillance",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "date",
                        "value" : {
                           "type" : "Add",
                           "operand" : [ {
                              "name" : "DateOfMostRecentReport",
                              "libraryName" : "Collate",
                              "type" : "ExpressionRef"
                           }, {
                              "value" : 5,
                              "unit" : "years",
                              "type" : "Quantity"
                           } ]
                        }
                     }, {
                        "name" : "details",
                        "value" : {
                           "type" : "List",
                           "element" : [ {
                              "name" : "FiveYearSurveillanceRecommendationText",
                              "type" : "ExpressionRef"
                           }, {
                              "name" : "J1RecommendationText",
                              "type" : "ExpressionRef"
                           } ]
                        }
                     } ]
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "Greater",
                        "operand" : [ {
                           "precision" : "Year",
                           "type" : "CalculateAge",
                           "operand" : {
                              "path" : "birthDate.value",
                              "type" : "Property",
                              "source" : {
                                 "name" : "Patient",
                                 "type" : "ExpressionRef"
                              }
                           }
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                           "value" : "65",
                           "type" : "Literal"
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "TableRecommendation",
                           "type" : "ExpressionRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "5-year follow-up",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "short",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "Surveillance",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "date",
                        "value" : {
                           "type" : "Add",
                           "operand" : [ {
                              "name" : "DateOfMostRecentReport",
                              "libraryName" : "Collate",
                              "type" : "ExpressionRef"
                           }, {
                              "value" : 5,
                              "unit" : "years",
                              "type" : "Quantity"
                           } ]
                        }
                     }, {
                        "name" : "details",
                        "value" : {
                           "type" : "List",
                           "element" : [ {
                              "name" : "FiveYearSurveillanceRecommendationText",
                              "type" : "ExpressionRef"
                           }, {
                              "name" : "J1RecommendationText",
                              "type" : "ExpressionRef"
                           }, {
                              "name" : "Over65RecommendationText",
                              "type" : "ExpressionRef"
                           } ]
                        }
                     } ]
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "GreaterOrEqual",
                        "operand" : [ {
                           "precision" : "Year",
                           "type" : "CalculateAge",
                           "operand" : {
                              "path" : "birthDate.value",
                              "type" : "Property",
                              "source" : {
                                 "name" : "Patient",
                                 "type" : "ExpressionRef"
                              }
                           }
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                           "value" : "25",
                           "type" : "Literal"
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "TableRecommendation",
                           "type" : "ExpressionRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "Colposcopy",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "short",
                        "value" : {
                           "name" : "TableRecommendation",
                           "type" : "ExpressionRef"
                        }
                     }, {
                        "name" : "date",
                        "value" : {
                           "type" : "Today"
                        }
                     }, {
                        "name" : "details",
                        "value" : {
                           "type" : "List",
                           "element" : [ {
                              "name" : "ColposcopyRecommendationText",
                              "type" : "ExpressionRef"
                           } ]
                        }
                     } ]
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "GreaterOrEqual",
                           "operand" : [ {
                              "precision" : "Year",
                              "type" : "CalculateAge",
                              "operand" : {
                                 "path" : "birthDate.value",
                                 "type" : "Property",
                                 "source" : {
                                    "name" : "Patient",
                                    "type" : "ExpressionRef"
                                 }
                              }
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                              "value" : "25",
                              "type" : "Literal"
                           } ]
                        }, {
                           "type" : "LessOrEqual",
                           "operand" : [ {
                              "precision" : "Year",
                              "type" : "CalculateAge",
                              "operand" : {
                                 "path" : "birthDate.value",
                                 "type" : "Property",
                                 "source" : {
                                    "name" : "Patient",
                                    "type" : "ExpressionRef"
                                 }
                              }
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                              "value" : "50",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "TableRecommendation",
                           "type" : "ExpressionRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "Colposcopy/Treatment",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "short",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "Colposcopy or Treatment",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "date",
                        "value" : {
                           "type" : "Today"
                        }
                     }, {
                        "name" : "details",
                        "value" : {
                           "type" : "List",
                           "element" : [ {
                              "name" : "ColposcopyOrTreatmentRecommendationText",
                              "type" : "ExpressionRef"
                           }, {
                              "name" : "TreatmentWithPregnancyConcernsRecommendationText",
                              "type" : "ExpressionRef"
                           } ]
                        }
                     } ]
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "Greater",
                        "operand" : [ {
                           "precision" : "Year",
                           "type" : "CalculateAge",
                           "operand" : {
                              "path" : "birthDate.value",
                              "type" : "Property",
                              "source" : {
                                 "name" : "Patient",
                                 "type" : "ExpressionRef"
                              }
                           }
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                           "value" : "50",
                           "type" : "Literal"
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "TableRecommendation",
                           "type" : "ExpressionRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "Colposcopy/Treatment",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "short",
                        "value" : {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "Colposcopy or Treatment",
                           "type" : "Literal"
                        }
                     }, {
                        "name" : "date",
                        "value" : {
                           "type" : "Today"
                        }
                     }, {
                        "name" : "details",
                        "value" : {
                           "type" : "List",
                           "element" : [ {
                              "name" : "ColposcopyOrTreatmentRecommendationText",
                              "type" : "ExpressionRef"
                           } ]
                        }
                     } ]
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "And",
                        "operand" : [ {
                           "type" : "GreaterOrEqual",
                           "operand" : [ {
                              "precision" : "Year",
                              "type" : "CalculateAge",
                              "operand" : {
                                 "path" : "birthDate.value",
                                 "type" : "Property",
                                 "source" : {
                                    "name" : "Patient",
                                    "type" : "ExpressionRef"
                                 }
                              }
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                              "value" : "25",
                              "type" : "Literal"
                           } ]
                        }, {
                           "type" : "LessOrEqual",
                           "operand" : [ {
                              "precision" : "Year",
                              "type" : "CalculateAge",
                              "operand" : {
                                 "path" : "birthDate.value",
                                 "type" : "Property",
                                 "source" : {
                                    "name" : "Patient",
                                    "type" : "ExpressionRef"
                                 }
                              }
                           }, {
                              "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                              "value" : "50",
                              "type" : "Literal"
                           } ]
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "TableRecommendation",
                           "type" : "ExpressionRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "Treatment",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "short",
                        "value" : {
                           "name" : "TableRecommendation",
                           "type" : "ExpressionRef"
                        }
                     }, {
                        "name" : "date",
                        "value" : {
                           "type" : "Today"
                        }
                     }, {
                        "name" : "details",
                        "value" : {
                           "type" : "List",
                           "element" : [ {
                              "name" : "TreatmentRecommendationText",
                              "type" : "ExpressionRef"
                           }, {
                              "name" : "TreatmentWithPregnancyConcernsRecommendationText",
                              "type" : "ExpressionRef"
                           } ]
                        }
                     } ]
                  }
               }, {
                  "when" : {
                     "type" : "And",
                     "operand" : [ {
                        "type" : "Greater",
                        "operand" : [ {
                           "precision" : "Year",
                           "type" : "CalculateAge",
                           "operand" : {
                              "path" : "birthDate.value",
                              "type" : "Property",
                              "source" : {
                                 "name" : "Patient",
                                 "type" : "ExpressionRef"
                              }
                           }
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                           "value" : "50",
                           "type" : "Literal"
                        } ]
                     }, {
                        "type" : "Equal",
                        "operand" : [ {
                           "name" : "TableRecommendation",
                           "type" : "ExpressionRef"
                        }, {
                           "valueType" : "{urn:hl7-org:elm-types:r1}String",
                           "value" : "Treatment",
                           "type" : "Literal"
                        } ]
                     } ]
                  },
                  "then" : {
                     "type" : "Tuple",
                     "element" : [ {
                        "name" : "short",
                        "value" : {
                           "name" : "TableRecommendation",
                           "type" : "ExpressionRef"
                        }
                     }, {
                        "name" : "date",
                        "value" : {
                           "type" : "Today"
                        }
                     }, {
                        "name" : "details",
                        "value" : {
                           "type" : "List",
                           "element" : [ {
                              "name" : "TreatmentRecommendationText",
                              "type" : "ExpressionRef"
                           } ]
                        }
                     } ]
                  }
               } ],
               "else" : {
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  },
                  "asTypeSpecifier" : {
                     "type" : "TupleTypeSpecifier",
                     "element" : [ {
                        "name" : "short",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "date",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}Date",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "details",
                        "type" : {
                           "type" : "ListTypeSpecifier",
                           "elementType" : {
                              "name" : "{urn:hl7-org:elm-types:r1}String",
                              "type" : "NamedTypeSpecifier"
                           }
                        }
                     } ]
                  }
               }
            }
         }, {
            "name" : "Recommendation",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "Tuple",
               "element" : [ {
                  "name" : "short",
                  "value" : {
                     "path" : "short",
                     "type" : "Property",
                     "source" : {
                        "name" : "Action",
                        "type" : "ExpressionRef"
                     }
                  }
               }, {
                  "name" : "date",
                  "value" : {
                     "path" : "date",
                     "type" : "Property",
                     "source" : {
                        "name" : "Action",
                        "type" : "ExpressionRef"
                     }
                  }
               }, {
                  "name" : "details",
                  "value" : {
                     "path" : "details",
                     "type" : "Property",
                     "source" : {
                        "name" : "Action",
                        "type" : "ExpressionRef"
                     }
                  }
               }, {
                  "name" : "group",
                  "value" : {
                     "name" : "CommonAbnormalityGroup",
                     "type" : "ExpressionRef"
                  }
               } ]
            }
         }, {
            "name" : "TableTitle",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "valueType" : "{urn:hl7-org:elm-types:r1}String",
               "value" : "Risk Estimates",
               "type" : "Literal"
            }
         }, {
            "name" : "TableSubtitle",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "name" : "CommonAbnormalityGroup",
               "type" : "ExpressionRef"
            }
         }, {
            "name" : "HeaderTable1",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "List",
               "element" : [ {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "history",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "History",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "hpv",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Current HPV Result",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "cyto",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Current Cytology Result",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "riskNow",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN 3+ Immediate Risk (%)",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "risk5yr",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN 3+ 5 yr Risk (%)",
                        "type" : "Literal"
                     }
                  } ]
               } ]
            }
         }, {
            "name" : "HeaderTable2",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "List",
               "element" : [ {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "prev2",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Second Previous",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "prev1",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Previous",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "hpv",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Current HPV Result",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "cyto",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Current Cytology Result",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "riskNow",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN 3+ Immediate Risk (%)",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "risk5yr",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN 3+ 5 yr Risk (%)",
                        "type" : "Literal"
                     }
                  } ]
               } ]
            }
         }, {
            "name" : "HeaderTable3",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "List",
               "element" : [ {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "referral",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Referring Result",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "biopsy",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Biopsy Result",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "riskNow",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN 3+ Immediate Risk (%)",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "risk5yr",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN 3+ 5 yr Risk (%)",
                        "type" : "Literal"
                     }
                  } ]
               } ]
            }
         }, {
            "name" : "HeaderTable4",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "List",
               "element" : [ {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "preColposcopyResult",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Pre-Colposcopy History",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "postColposcopyPastHistory",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Post-Colposcopy History",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "hpv",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Current HPV Result",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "cyto",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Current Cytology Result",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "riskNow",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN 3+ Immediate Risk (%)",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "risk5yr",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN 3+ 5 yr Risk (%)",
                        "type" : "Literal"
                     }
                  } ]
               } ]
            }
         }, {
            "name" : "HeaderTable5",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "List",
               "element" : [ {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "biopsy",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Biopsy Result",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "hpv",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Current HPV Result",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "cyto",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "Current Cytology Result",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "riskNow",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN 3+ Immediate Risk (%)",
                        "type" : "Literal"
                     }
                  } ]
               }, {
                  "type" : "Tuple",
                  "element" : [ {
                     "name" : "key",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "risk5yr",
                        "type" : "Literal"
                     }
                  }, {
                     "name" : "display",
                     "value" : {
                        "valueType" : "{urn:hl7-org:elm-types:r1}String",
                        "value" : "CIN 3+ 5 yr Risk (%)",
                        "type" : "Literal"
                     }
                  } ]
               } ]
            }
         }, {
            "name" : "TableHeaders",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "Case",
               "caseItem" : [ {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "5",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "HeaderTable5",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "4",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "HeaderTable4",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "3",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "HeaderTable3",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "2",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "HeaderTable2",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "1",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "HeaderTable1",
                     "type" : "ExpressionRef"
                  }
               } ],
               "else" : {
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  },
                  "asTypeSpecifier" : {
                     "type" : "ListTypeSpecifier",
                     "elementType" : {
                        "type" : "TupleTypeSpecifier",
                        "element" : [ {
                           "name" : "key",
                           "type" : {
                              "name" : "{urn:hl7-org:elm-types:r1}String",
                              "type" : "NamedTypeSpecifier"
                           }
                        }, {
                           "name" : "display",
                           "type" : {
                              "name" : "{urn:hl7-org:elm-types:r1}String",
                              "type" : "NamedTypeSpecifier"
                           }
                        } ]
                     }
                  }
               }
            }
         }, {
            "name" : "RelevantRow",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "Case",
               "caseItem" : [ {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "5",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "RowTable5",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "4",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "RowTable4",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "3",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "RowTable3",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "2",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "RowTable2",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "1",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "RowTable1",
                     "type" : "ExpressionRef"
                  }
               } ],
               "else" : {
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  },
                  "asTypeSpecifier" : {
                     "type" : "TupleTypeSpecifier",
                     "element" : [ {
                        "name" : "action",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "history",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "prev2",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "prev1",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "referral",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "biopsy",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "preColposcopyResult",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "postColposcopyPastHistory",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "hpv",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "cyto",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}String",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "riskNow",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}Decimal",
                           "type" : "NamedTypeSpecifier"
                        }
                     }, {
                        "name" : "risk5yr",
                        "type" : {
                           "name" : "{urn:hl7-org:elm-types:r1}Decimal",
                           "type" : "NamedTypeSpecifier"
                        }
                     } ]
                  }
               }
            }
         }, {
            "name" : "AdjacentRows",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "Case",
               "caseItem" : [ {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "5",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "AdjacentRowsTable5",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "4",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "AdjacentRowsTable4",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "3",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "AdjacentRowsTable3",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "2",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "AdjacentRowsTable2",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "when" : {
                     "type" : "Equal",
                     "operand" : [ {
                        "name" : "WhichTableMadeTheRecommendation",
                        "type" : "ExpressionRef"
                     }, {
                        "valueType" : "{urn:hl7-org:elm-types:r1}Integer",
                        "value" : "1",
                        "type" : "Literal"
                     } ]
                  },
                  "then" : {
                     "name" : "AdjacentRowsTable1",
                     "type" : "ExpressionRef"
                  }
               } ],
               "else" : {
                  "type" : "As",
                  "operand" : {
                     "type" : "Null"
                  },
                  "asTypeSpecifier" : {
                     "type" : "ListTypeSpecifier",
                     "elementType" : {
                        "type" : "TupleTypeSpecifier",
                        "element" : [ {
                           "name" : "action",
                           "type" : {
                              "name" : "{urn:hl7-org:elm-types:r1}String",
                              "type" : "NamedTypeSpecifier"
                           }
                        }, {
                           "name" : "history",
                           "type" : {
                              "name" : "{urn:hl7-org:elm-types:r1}String",
                              "type" : "NamedTypeSpecifier"
                           }
                        }, {
                           "name" : "prev2",
                           "type" : {
                              "name" : "{urn:hl7-org:elm-types:r1}String",
                              "type" : "NamedTypeSpecifier"
                           }
                        }, {
                           "name" : "prev1",
                           "type" : {
                              "name" : "{urn:hl7-org:elm-types:r1}String",
                              "type" : "NamedTypeSpecifier"
                           }
                        }, {
                           "name" : "preColposcopyResult",
                           "type" : {
                              "name" : "{urn:hl7-org:elm-types:r1}String",
                              "type" : "NamedTypeSpecifier"
                           }
                        }, {
                           "name" : "postColposcopyPastHistory",
                           "type" : {
                              "name" : "{urn:hl7-org:elm-types:r1}String",
                              "type" : "NamedTypeSpecifier"
                           }
                        }, {
                           "name" : "referral",
                           "type" : {
                              "name" : "{urn:hl7-org:elm-types:r1}String",
                              "type" : "NamedTypeSpecifier"
                           }
                        }, {
                           "name" : "biopsy",
                           "type" : {
                              "name" : "{urn:hl7-org:elm-types:r1}String",
                              "type" : "NamedTypeSpecifier"
                           }
                        }, {
                           "name" : "hpv",
                           "type" : {
                              "name" : "{urn:hl7-org:elm-types:r1}String",
                              "type" : "NamedTypeSpecifier"
                           }
                        }, {
                           "name" : "cyto",
                           "type" : {
                              "name" : "{urn:hl7-org:elm-types:r1}String",
                              "type" : "NamedTypeSpecifier"
                           }
                        }, {
                           "name" : "riskNow",
                           "type" : {
                              "name" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "type" : "NamedTypeSpecifier"
                           }
                        }, {
                           "name" : "risk5yr",
                           "type" : {
                              "name" : "{urn:hl7-org:elm-types:r1}Decimal",
                              "type" : "NamedTypeSpecifier"
                           }
                        } ]
                     }
                  }
               }
            }
         }, {
            "name" : "RiskTableSummary",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "Tuple",
               "element" : [ {
                  "name" : "title",
                  "value" : {
                     "name" : "TableTitle",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "name" : "subtitle",
                  "value" : {
                     "name" : "TableSubtitle",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "name" : "headers",
                  "value" : {
                     "name" : "TableHeaders",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "name" : "relevant",
                  "value" : {
                     "name" : "RelevantRow",
                     "type" : "ExpressionRef"
                  }
               }, {
                  "name" : "adjacent",
                  "value" : {
                     "name" : "AdjacentRows",
                     "type" : "ExpressionRef"
                  }
               } ]
            }
         }, {
            "name" : "Errors",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "List"
            }
         }, {
            "name" : "ErrorsHaveOccurred",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "Exists",
               "operand" : {
                  "name" : "Errors",
                  "type" : "ExpressionRef"
               }
            }
         }, {
            "name" : "NoErrorsHaveOccurred",
            "context" : "Patient",
            "accessLevel" : "Public",
            "expression" : {
               "type" : "Not",
               "operand" : {
                  "name" : "ErrorsHaveOccurred",
                  "type" : "ExpressionRef"
               }
            }
         } ]
      }
   }
}

